export const selectAuthToken = (state: RootState) => state.auth.token;
